import { render, staticRenderFns } from "./TicketsHeaderCards.vue?vue&type=template&id=b8772a18&"
import script from "./TicketsHeaderCards.vue?vue&type=script&lang=ts&"
export * from "./TicketsHeaderCards.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsHeaderCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VHover,VProgressLinear,VRow,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8772a18')) {
      api.createRecord('b8772a18', component.options)
    } else {
      api.reload('b8772a18', component.options)
    }
    module.hot.accept("./TicketsHeaderCards.vue?vue&type=template&id=b8772a18&", function () {
      api.rerender('b8772a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/dashboard/components/TicketsHeaderCards.vue"
export default component.exports